import Default from './pages/Default.svelte'
import DescriptionPage from './pages/DescriptionPage.svelte'

const routes = {
    '/':Default,
    '/quienes-somos':Default,
    '/contactenos':Default,
    '/quienes-somos':DescriptionPage,
    '*':Default
}

export default routes